import '.c2{flex-shrink:0;}.ssr-plugin'
import '.c6{width:20rem;}.ssr-plugin'
import '.ak{border:var(--blue-border);}.ssr-plugin'
import '.ay{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.c3{padding:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.m{gap:2rem;}.ssr-plugin'
import '.c7{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="c2 c6 ak ay ad c3"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="d m c7"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
